import React, { useEffect, useState, useCallback } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Card, CardBody, Spinner } from "reactstrap"
import { get } from "helpers/api_helper"
import { REPORTS } from "helpers/url_helper"
import Barchart from "./componets/barchart"
import Piechart from "./componets/piechart"

const StatCard = ({ title, value, icon, gradientClass, iconColorClass }) => (
  <Col md={4} className="mb-3 mb-md-0">
    <div className={`mini-stats-wid p-3 premium-hover ${gradientClass}`}>
      <div className="d-flex align-items-center">
        <div className="avatar-sm rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '48px', height: '48px', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.05)' }}>
          <span className="avatar-title rounded-circle bg-transparent">
            <i className={`bx ${icon} ${iconColorClass} font-size-24`} />
          </span>
        </div>
        <div className="flex-grow-1">
          <p className="text-muted fw-medium mb-1" style={{ fontSize: '13px', letterSpacing: '0.02em' }}>{title}</p>
          <h3 className="mb-0 fw-bold text-dark">{value}</h3>
        </div>
      </div>
    </div>
  </Col>
)

const Dashboard = () => {
  const [data, setData] = useState({
    lifetime: {},
    today: {},
    last21Days: [],
    pieData: [],
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const getDashboardData = useCallback(async () => {
    try {
      setLoading(true)
      const { success, data } = await get(`${REPORTS}/dashboard`)
      if (success) {
        setData(data)
      } else {
        setError(true)
      }
    } catch {
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getDashboardData()
  }, [getDashboardData])

  if (loading) {
    return (
      <div className="page-content text-center mt-5">
        <Spinner color="primary" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="page-content text-center mt-5 text-danger">
        Failed to load dashboard data
      </div>
    )
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>Dashboard | {process.env.REACT_APP_TITLE}</title>
      </MetaTags>

      <Container fluid>
        {/* Lifetime */}
        <Card className="p-4 mb-4">
          <h5 className="mb-3 text-uppercase tracking-wider font-size-12" style={{ color: '#818cf8', letterSpacing: '0.1em' }}>Lifetime Metrics</h5>
          <Row>
            <StatCard
              title="Total Shipments"
              value={data.lifetime.total || 0}
              icon="bx-package"
              gradientClass="stat-card-gradient-1"
              iconColorClass="text-primary"
            />
            <StatCard
              title="Delivered"
              value={data.lifetime.delivered_count || 0}
              icon="bx-check-shield"
              gradientClass="stat-card-gradient-2"
              iconColorClass="text-success"
            />
            <StatCard
              title="Not Delivered (NDR)"
              value={data.lifetime.not_delivered_count || 0}
              icon="bx-error-circle"
              gradientClass="stat-card-gradient-3"
              iconColorClass="text-danger"
            />
          </Row>
        </Card>

        {/* Today */}
        <Card className="p-4 mb-4">
          <h5 className="mb-3 text-uppercase tracking-wider font-size-12" style={{ color: '#f59e0b', letterSpacing: '0.1em' }}>{"Today's Activity"}</h5>
          <Row>
            <StatCard 
              title="Today's Shipments" 
              value={data.today.total || 0} 
              icon="bx-calendar-event"
              gradientClass="stat-card-gradient-1"
              iconColorClass="text-primary"
            />
            <StatCard
              title="Pending for Pickup"
              value={data.today.pending || 0}
              icon="bx-time-five"
              gradientClass="stat-card-gradient-2"
              iconColorClass="text-warning"
            />
            <StatCard 
              title="Pickup Done (In Transit)" 
              value={data.today.in_transit || 0} 
              icon="bx-truck"
              gradientClass="stat-card-gradient-3"
              iconColorClass="text-info"
            />
          </Row>
        </Card>

        {/* Charts */}
        <Row>
          <Col md={8}>
            <Card>
              <CardBody>
                <Barchart series={data.last21Days} />
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card>
              <CardBody>
                <Piechart series={data.pieData} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Dashboard
